import React from 'react';
import '../../App.css';
import Hero from '../HeroEmpresaEn'
import Empresa from '../Empresa/EmpresaEn'
import Missao from '../Empresa/MissaoEn'
import MachRang from '../Empresa/MachRang'
import PolitGest from '../Empresa/PolitGestEn'
import SalesDist from '../Empresa/SalesDist'
import Footer from '../../Footer/FooterEn';

function Noticias(){
    return (
        <div>
            <Hero/>
            <Empresa/>
            <SalesDist/>
            <Missao/>
            <PolitGest/>
            <Footer/>
            
        </div>
    );
}

export default Noticias;
